import api from "../lib/api";

export const jobService = {
    getCalendarJobs: () => api.get('/company/jobs/calendar'),
    getJobById(id) {
        return api.get(`/company/jobs/${id}`);
    },
    updateJob(id, data) {
        return api.put(`/company/jobs/${id}`, data);
    }
};